class Accordion {
  constructor() {
    this.accordions = document.querySelectorAll(".accordion");
    this.events();
  }

  events() {
    this.accordions.forEach(accordion => {
      const trigger = accordion.querySelector(".accordion__trigger");
      const panel = accordion.querySelector(".accordion__panel");

      trigger.addEventListener("click", () => this.triggerAccordion(trigger, panel));
    });
  }

  triggerAccordion(trigger, panel) {
    if (panel.classList.contains("accordion__panel--active")) {
      trigger.classList.remove("accordion__trigger--active");
      panel.classList.remove("accordion__panel--active");
      panel.setAttribute("aria-expanded", "false");
    } else {
      trigger.classList.add("accordion__trigger--active");
      panel.classList.add("accordion__panel--active");
      panel.setAttribute("aria-expanded", "true");
    }
  }
}

export default Accordion;
